import { FormProps } from 'types/form';
import { CompanyOwner } from '../types/dtos';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import OWForm from 'components/layout/ow-form';
import { Button, Divider, Stack, TextField, Typography } from '@mui/material';
import PasswordField from 'features/auth/components/password-field';
import FormFooter from 'components/layout/form-footer';
import { LoadingButton } from '@mui/lab';
import { isEmpty } from 'lodash';

export type CompanyOwnerFormProps = FormProps<CompanyOwner> & { isEdit?: boolean };

type CompanyOwnerFormType = (props: CompanyOwnerFormProps) => ReactNode;

export const CompanyOwnerForm: CompanyOwnerFormType = ({
    formData: companyOwner,
    onSubmit,
    onChange,
    errors,
    onCancel,
    isSaveLoading,
    isEdit,
}) => {
    const { t } = useTranslation();

    return (
        <OWForm onSubmit={onSubmit}>
            <Typography variant="h6">{t('COMPANY_OWNER_FORM.HEADER')}</Typography>
            <Stack direction="row" spacing={1} alignItems="flex-start">
                <Stack width="100%" spacing={1.25}>
                    <TextField
                        value={companyOwner.email}
                        onChange={(e) => onChange('email', e.target.value)}
                        placeholder={t('COMPANY_OWNER_FORM.PLACEHOLDER_EMAIL')}
                        label={t('COMPANY_OWNER_FORM.LABEL_EMAIL')}
                        autoFocus
                        required
                        error={!!errors?.email}
                        helperText={errors?.email?.errorMessage}
                    />
                    <PasswordField
                        label={
                            isEdit ? t('COMPANY_OWNER_FORM.LABEL_NEW_PASSWORD') : t('COMPANY_OWNER_FORM.LABEL_PASSWORD')
                        }
                        placeholder={
                            isEdit
                                ? t('COMPANY_OWNER_FORM.PLACEHOLDER_NEW_PASSWORD')
                                : t('COMPANY_OWNER_FORM.PLACEHOLDER_ENTER_PASSWORD')
                        }
                        required={!isEdit}
                        value={companyOwner.password}
                        onChange={(e) => onChange('password', e.target.value)}
                        error={errors?.password}
                    />
                    <Divider variant="middle" />
                    <TextField
                        value={companyOwner.firstName}
                        onChange={(e) => onChange('firstName', e.target.value)}
                        placeholder={t('COMPANY_OWNER_FORM.PLACEHOLDER_FIRST_NAME')}
                        label={t('COMPANY_OWNER_FORM.LABEL_FIRST_NAME')}
                        required
                        error={!!errors?.firstName}
                        helperText={errors?.firstName?.errorMessage}
                    />
                    <TextField
                        value={companyOwner.lastName}
                        onChange={(e) => onChange('lastName', e.target.value)}
                        placeholder={t('COMPANY_OWNER_FORM.PLACEHOLDER_LAST_NAME')}
                        label={t('COMPANY_OWNER_FORM.LABEL_LAST_NAME')}
                        required
                        error={!!errors?.lastName}
                        helperText={errors?.lastName?.errorMessage}
                    />

                    <TextField
                        value={companyOwner.phoneNumber}
                        onChange={(e) => onChange('phoneNumber', e.target.value)}
                        placeholder={t('COMPANY_OWNER_FORM.PLACEHOLDER_PHONE_NUMBER')}
                        label={t('COMPANY_OWNER_FORM.LABEL_PHONE_NUMBER')}
                        required
                        error={!!errors?.phoneNumber}
                        helperText={errors?.phoneNumber?.errorMessage}
                    />
                </Stack>
                <FormFooter>
                    <Stack direction="row" width="360px" spacing={3}>
                        <Button variant="outlined" onClick={onCancel}>
                            {t('PLACE_FORM.CANCEL')}
                        </Button>
                        <LoadingButton loading={isSaveLoading} type="submit" disabled={!isEmpty(errors)}>
                            {t('PLACE_FORM.SUBMIT')}
                        </LoadingButton>
                    </Stack>
                </FormFooter>
            </Stack>
        </OWForm>
    );
};
